import React from 'react';
import loginBg from '../../assets/login-bg.png';

export const AuthLayout = ({ children, title, subtitle }) => (
  <div className="min-h-screen flex" data-testid="auth-layout">
    {/* Left: Background image */}
    <div
      className="hidden lg:flex lg:w-1/2 items-center justify-center p-12 relative"
      style={{
        backgroundImage: `url(${loginBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-black/60" />
      <div className="relative z-10 text-center">
        <h1 className="text-5xl font-black uppercase tracking-wider mb-4"
          style={{ fontFamily: "'Barlow Condensed', sans-serif", color: '#E3000F' }}>
          VVF Interventi
        </h1>
        <p className="text-[#A1A1AA] text-lg">Sistema Gestione Interventi</p>
      </div>
    </div>

    {/* Right: Form */}
    <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-[#0A0A0A]">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center lg:text-left">
          <h2 className="text-3xl font-bold uppercase tracking-wider"
            style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
            {title}
          </h2>
          {subtitle && <p className="text-[#71717A] mt-2">{subtitle}</p>}
        </div>
        {children}
      </div>
    </div>
  </div>
);
